import { useEffect, useState } from 'react';

// Matches viewports narrower than the design system `sm` breakpoint (600px),
// see `@latitude/theme` tailwind breakpoints.
export const MOBILE_VIEWPORT_MEDIA_QUERY = '(max-width: 599px)';

const getMediaQuery = () =>
  typeof window === 'undefined'
    ? null
    : window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY);

// The first render already reports the real value so a gated page is never
// mounted on mobile. Callers must render client-side only (in onboarding the
// hook sits below `ClientReadyGate`); during SSR it reports `false`.
export const useIsMobileViewport = (): boolean => {
  const [isMobileViewport, setIsMobileViewport] = useState(
    () => getMediaQuery()?.matches ?? false,
  );

  useEffect(() => {
    const mediaQuery = getMediaQuery();
    if (!mediaQuery) {
      return;
    }
    setIsMobileViewport(mediaQuery.matches);

    const handleChange = (event: { matches: boolean }) => {
      setIsMobileViewport(event.matches);
    };
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return isMobileViewport;
};
